import * as FavoritesUpdatedEvent from '@ori-events/favorites-updated';
import { HeartsAnimation } from '@ori/favorites-heart';
import { usePersonalBeautyStore } from '@ori/personal-beauty-store';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';
import { useEffect, useState, useCallback } from 'react';

import { useAppConfig } from '../../../context';
import { useToggleMenu } from '../../../hooks';
import { useTranslations } from '../../../hooks/useTranslations';
import { BURGER_MENU } from '../constants';
import { BurgerMenuIconLine, BurgerMenuIconRoot, BurgerMenuIconWrapper } from './styles';

export const BurgerMenuIcon: FC = () => {
  const [menuIsOpen, toggleMenu] = useToggleMenu();
  const [wasFavoriteAdded, setWasFavoriteAdded] = useState(false);
  const {
    tooltipWasShown: pbsTooltipWasShown,
    setTooltipWasShown: setPbsTooltipWasShown,
    pbsData,
  } = usePersonalBeautyStore();

  const { pbsIconInBurgerMenu } = useAppConfig();
  const { formatMessage } = useTranslations();
  const ownerState = { isOpen: menuIsOpen };
  const { getTestId } = useTestId();

  const onClickCallback = useCallback(() => {
    const { firstName, lastName } = pbsData?.beautyStore?.profile ?? {};

    if (!pbsTooltipWasShown && pbsIconInBurgerMenu && firstName && lastName) {
      setPbsTooltipWasShown(true);
    }

    toggleMenu();
  }, [pbsTooltipWasShown, toggleMenu, setPbsTooltipWasShown, pbsIconInBurgerMenu, pbsData?.beautyStore?.profile]);

  const onFavoritesUpdated = ({ detail: { favorites, lastUpdated } }: FavoritesUpdatedEvent.Event) => {
    if (lastUpdated && favorites.includes(lastUpdated)) {
      setWasFavoriteAdded(() => true);

      setTimeout(() => {
        setWasFavoriteAdded(() => false);
      }, 0);
    }
  };

  useEffect(() => {
    window.addEventListener(FavoritesUpdatedEvent.Name, onFavoritesUpdated as EventListener);

    return () => {
      window.removeEventListener(FavoritesUpdatedEvent.Name, onFavoritesUpdated as EventListener);
    };
  }, []);

  return (
    <BurgerMenuIconRoot
      disableRipple
      aria-label={formatMessage('menu')}
      ownerState={ownerState}
      data-testid={getTestId(BURGER_MENU)}
      onClick={onClickCallback}
    >
      <BurgerMenuIconWrapper ownerState={{ ...ownerState, isMobile: true }}>
        <HeartsAnimation
          shouldAnimationRun
          state={wasFavoriteAdded}
        >
          <BurgerMenuIconLine
            ownerState={ownerState}
            className="burgerMenuIconLine"
          />
          <BurgerMenuIconLine
            ownerState={ownerState}
            className="burgerMenuIconLine"
          />
          <BurgerMenuIconLine
            ownerState={ownerState}
            className="burgerMenuIconLine"
          />
        </HeartsAnimation>
      </BurgerMenuIconWrapper>
      <BurgerMenuIconWrapper>
        <BurgerMenuIconLine
          ownerState={ownerState}
          className="burgerMenuIconLine"
        />
        <BurgerMenuIconLine
          ownerState={ownerState}
          className="burgerMenuIconLine"
        />
        <BurgerMenuIconLine
          ownerState={ownerState}
          className="burgerMenuIconLine"
        />
      </BurgerMenuIconWrapper>
    </BurgerMenuIconRoot>
  );
};
